/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemoveFriendResponse
 */
export interface RemoveFriendResponse {
    /**
     * 
     * @type {boolean}
     * @memberof RemoveFriendResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof RemoveFriendResponse
     */
    message: string;
}

/**
 * Check if a given object implements the RemoveFriendResponse interface.
 */
export function instanceOfRemoveFriendResponse(value: object): value is RemoveFriendResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function RemoveFriendResponseFromJSON(json: any): RemoveFriendResponse {
    return RemoveFriendResponseFromJSONTyped(json, false);
}

export function RemoveFriendResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemoveFriendResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
    };
}

export function RemoveFriendResponseToJSON(json: any): RemoveFriendResponse {
    return RemoveFriendResponseToJSONTyped(json, false);
}

export function RemoveFriendResponseToJSONTyped(value?: RemoveFriendResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
    };
}

